import { createContext } from 'react'
import rootStore from '@/stores/RootStore.js'

export const StoreContext = createContext(rootStore)
StoreContext.displayName = 'RootStore'

export const RepositoryContext = createContext(rootStore.repositories)
RepositoryContext.displayName = 'RootStore.repositories'

export const ViewContext = createContext(rootStore.views)
ViewContext.displayName = 'RootStore.views'
